module.exports = __webpack_public_path__ + "02_glasses_red.914f27de.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/02_glasses_red.png
// module id = II5j
// module chunks = 0